/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { Remember } from '@/model/global/GlobalSettings'

const entity = {
  name: {
    displayName: 'staff'
  },
  password: {},
  sumPersonCount: {
    displayName: 'Customers'
  },
  orderCount: {
    displayName: 'Order'
  },
  sumTotalPrice: {
    type: IKDataEntity.Types.Float
  },
  _paymentInfo: {
    displayName: 'PaymentMethods'
  },
  sumTipIncome: {
    type: IKDataEntity.Types.Float
  }
}
const config = {
  load: async function (filter) {
    const [fromDate, toDate] = [filter[0].dateFilter[0], filter[0].dateFilter[1]]
    const res = (await hillo.get('BackendData.php?op=servantReportV2', {
      fromDate,
      toDate
    })).content
    res.forEach(it => {
      if (it.paymentInfo) {
        it?.paymentInfo?.forEach(a => {
          a.percent = (a.sumPaymentAmount / it.sumTotalPrice * 100).toFixed(2) + ' %'
          a._langsname = a.langs.find(c => c.lang.toLowerCase() === Remember.lang.toLowerCase()).name
        })
        it._paymentInfo = it.paymentInfo.map(f => f._langsname + ': ' + f.sumPaymentAmount + ' (' + f.percent + ')').join(' | ')
      }
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
